import { combineReducers } from '@reduxjs/toolkit'
import namespaces from './NamespaceList/namespaceListSlice'
import editor from './WebTextEditor/webTextEditorSlice'

export default combineReducers({
	namespaces,
	editor
})